                
             
                
                  
                      
 

const POSTS_API_URL = "/api/posts";

async function getPosts()                  {
  return fetch(POSTS_API_URL).then((resp) => resp.json());
}

                     
export { getPosts };
